// extracted by mini-css-extract-plugin
module.exports = {"auto_search":"auto_search-2jy8HJy0","txt":"txt-3Mulkyvd","btn":"btn-IK0U5lDu"};